<template>
  <div></div>
</template>
<script></script>
<style lang="sass">

    @import ../../common/styles/settings

    .view-newsfeed
        position: relative
        padding-top: 3rem
        padding-bottom: 3rem
        background: #FECC32 url(../../common/assets/background-newsfeed.png) no-repeat center center / cover

        .title--2
            color: white

        &__slider
            display: flex
            justify-content: center
            margin: 1.75rem 3.75rem 1rem

        &__slide
            flex-basis: 33.333333%
            display: block
            margin: 0 .625rem
            background-color: white

            .card__cover
                min-width: 100%
                max-width: 100%

            p
                margin-bottom: 0

            &__body
                padding: 1.25rem

                > * + *
                    margin-top: .75rem

        &__nav
            position: absolute
            top: 50%
            width: 1.75rem
            height: 1.75rem
            cursor: pointer
            transform: scale(.9)
            transition: transform $speed-normal $authentic-motion

            &--left
                left: 0
                &:hover
                    transform: translateX(-25%)

            &--right
                right: 0
                &:hover
                    transform: translateX(25%)

            svg
                height: inherit
                width: inherit
                stroke: white


</style>
